import { SREvents } from "../SignalR/models";
import { uniqueKey } from "../utils/uniqueKey";

const currentSession = {
    // there is no ep.settings for anonymous custom form
    id: `${ep.settings?.accountId ?? "-"}:${ep.settings?.currentUserId ?? "-"}:${uniqueKey()}`,
};

export const isOwnSignalREvent = (e: SREvents) => e.SessionId === currentSession.id;

export const getSessionIdHeader = () => ({ ["ep-session"]: currentSession.id });

export const addSessionIdHeader = (requestOptions: JQuery.AjaxSettings) => {
    requestOptions.headers = {
        ...getSessionIdHeader(),
        ...requestOptions.headers,
    };
};

export const internal = { currentSession };
